export default "__VITE_ASSET__ctllJMVk__"